import * as PIXI from 'pixi.js';
import * as PrefabManager from '../PrefabManager'
import { SliceObject } from './SliceObject';
import {
    game
} from "../../Game";

// The sword's grip, crossguard and blade, fitted to its art where the katana's art sits.
const SWORD_VERTICES = [
    [{x: -0.115, y: 2.002}, {x: -0.115, y: 1.036}, {x: 0.218, y: 1.036}, {x: 0.218, y: 2.002}],
    [{x: -0.515, y: 1.036}, {x: -0.515, y: 0.802}, {x: 0.618, y: 0.802}, {x: 0.618, y: 1.036}],
    [{x: -0.082, y: 0.802}, {x: -0.082, y: -3.064}, {x: 0.052, y: -3.564}, {x: 0.185, y: -3.064}, {x: 0.185, y: 0.802}],
];
const PER_FIXTURE = ['colorFill', 'colorLine', 'transparancy', 'density', 'radius', 'lineWidth', 'friction', 'restitution'];

class Katana extends SliceObject {
    constructor(target) {
        super(target);
        this.flipped = false;
        this.skin = Katana.skins.katana;
        this.katanaVertices = JSON.parse(JSON.stringify(this.lookupObject.sliceBody.mySprite.data.vertices));
        if(this.prefabObject.settings){
			this.flip(this.prefabObject.settings.isFlipped);
		}
    }
    init() {
		super.init();
    }
    flip(flipped){
        if(this.flipped != flipped){
            this.flipped = flipped;
            game.editor.mirrorPrefab(this, 'sliceBody');
        }
    }
    set(property, value) {
		super.set(property, value);
        switch (property) {
            case 'isFlipped':
                this.flip(value);
            break
            case 'skin':
                this.setSkin(value);
            break
        }
    }
    setSkin(skin){
        if(this.skin === skin) return;
        this.skin = skin;
        const body = this.lookupObject.sliceBody;
        const data = body.mySprite.data;
        const sword = skin === Katana.skins.sword;
        const mass = body.GetMass();
        // A flip mirrors the fixtures in place, so the new shapes are mirrored to match.
        data.vertices = (sword ? SWORD_VERTICES : this.katanaVertices).map(points => points.map(({x, y}) => ({x: this.flipped ? -x : x, y})));
        PER_FIXTURE.forEach(key => data[key] = data.vertices.map(() => data[key][0]));
        game.editor.updateBodyFixtures(body);
        // Both blades weigh the same, so they swing and fall alike.
        const scale = mass / body.GetMass();
        for (let fixture = body.GetFixtureList(); Box2D.getPointer(fixture) !== Box2D.getPointer(Box2D.NULL); fixture = fixture.GetNext()) {
            fixture.SetDensity(fixture.GetDensity() * scale);
        }
        body.ResetMassData();
        game.editor.updateBodyShapes(body);
        game.editor.setBodyCollision(body, data.collision);
        const sprite = body.myTexture.originalSprite;
        sprite.texture = PIXI.Texture.from(sword ? 'Sword0000' : 'Katana0000');
        body.myTexture.pivot.set(sprite.width / 2, sprite.height / 2);
    }
}

Katana.skins = {
    katana: 'Katana',
    sword: 'Sword',
};

Katana.settings = Object.assign({}, Katana.settings, {
	"isFlipped": false,
	"skin": Katana.skins.katana,
});
Katana.settingsOptions = Object.assign({}, Katana.settingsOptions, {
	"isFlipped": false,
	"skin": Object.values(Katana.skins),
});

PrefabManager.prefabLibrary.Katana = {
    json: '{"objects":[[0,-0.08800712444386306,0.9331496389670001,0,"katana","sliceBody",0,["#999999","#999999"],["#000","#000"],[0,0,0],false,true,[[{"x":-0.21486975363413616,"y":2.104038819379681},{"x":-0.21486975363413616,"y":0.7378957174174422},{"x":0.33114027361590553,"y":0.7378957174174422},{"x":0.33114027361590553,"y":2.104038819379681}],[{"x":-0.06296855286917794,"y":-3.5736255664706107},{"x":0.386885132608228,"y":0.7064463482366499},{"x":-0.04669803288740827,"y":0.7316910296734873},{"x":-0.4031556525899976,"y":-3.5483808850337732}]],[1,1],0,[0,0],"",[1,1]],[1,-1.0959280721914406,3.5676797050588505,-3.141592653589792,"katana","sharpTexture",1,"Katana0000",0,24.475576373015777,1.5076594222935575,3.141592653589792,false,"#FFFFFF",1,1,1]]}',
    class: Katana,
    library: PrefabManager.LIBRARY_WEAPON  ,
}
